module.exports = ".double_border_top {\r\n\tborder-top: 3px double #dee2e6;\r\n}\r\n\r\n.double_border_left {\r\n\tborder-left: 3px double #dee2e6;\r\n}"